import React, { Fragment } from "react";
import classNames from "classnames";

import Logo from "~/assets/images/login/login-logo.svg";
import { ReactComponent as Completed }  from "~/assets/images/checkin/completed.svg";


const Claimed = ({message, setOverlayOpen})=> {

  return (
    <Fragment>
      <div className={classNames("reward-request-overlay")}>

        <div> <img src={Logo}/> </div>
        <Completed />

        { message && <div className="text-center">
          <h6 className="text-success"> {message} </h6>
          <p>If you like our app please give us a review on Trustpilot
            ( <a href="https://uk.trustpilot.com/review/earndorado.com" target="_blank"><strong>EarnDorado is rated "Excellent" with 4.4 / 5 &#11088; on <span className="text-success">Trustpilot</span></strong></a>)
            and we will speed up the request process!
          </p>
        </div>
        }

        <button className="close-btn" onClick={()=> setOverlayOpen({completed: false})}>Close</button>
      </div>
    </Fragment>
  );
};

export default Claimed;
